import StepProgressionActions from './constants';
import { IActionObject, IStepProgressionInterface } from './types';

const INITIAL_STATE: IStepProgressionInterface = {
  stepProgression: false,
};

export default function stepProgressionReducers(
  state = INITIAL_STATE,
  action: IActionObject
): IStepProgressionInterface {
  const { data } = action;
  switch (action.type) {
    case StepProgressionActions.ENABLE_PROGRESSION:
      return data.stepProgression;
    case StepProgressionActions.DISABLE_PROGRESSION:
      return data.stepProgression;
    default:
      return state;
  }
}
